import materialUI from "material-UI";
import styled from "styled-components";

export const Modal = styled(materialUI.Dialog)`
  .MuiDialog-paper {
    overflow: unset;
  }
  /* .MuiDialog-paperWidthSm {
    max-width: 1000px;
    max-height: min-content;
  } */
`;
